import Header from "components/Headers/Header";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
} from "reactstrap";
import { fetchCryptoListing } from "../../redux/Crypto/CryptoAction";
import Unauthorized from "views/Pages/Unauthorized";
import Moment from "react-moment";

function Crypto(props) {
  const [unauthorized, setUnauthorized] = useState(false);
  const [startDate, setStartDate] = useState(false);
  const [endDate, setEndDate] = useState(false);

  useEffect(() => {
    let d = new Date();
    let end = formatDate(d);
    d.setMonth(d.getMonth() - 1);
    let start = formatDate(d);
    setStartDate(start);
    setEndDate(end);
    props.fetchCryptoListing(start, end);
  }, []);

  if (props.cryptoError && !unauthorized) {
    if (props.cryptoError.status === 403) {
      setUnauthorized(true);
    } else if (props.cryptoError.status === 440) {
      props.resetState();
      toast.error(props.cryptoError.message, {
        position: toast.POSITION.TOP_CENTER,
      });
      props.history.push("/auth/login");
    }
  }

  //for formating date acc. to input type date
  const formatDate = (d) => {
    let month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };

  const renderTaxesTableData = () => {
    return props.cryptodata.map((crypto, i) => {
      return (
        <tr key={i}>
          <td>{crypto.id}</td>
          <td>
            <Moment format="MM/DD/YY HH:mm" tz="America/Los_Angeles">
              {crypto.ticketTime.toString().length === 10
                ? new Date(crypto.ticketTime * 1000)
                : new Date(crypto.ticketTime)}
            </Moment>
          </td>
          <td>${crypto.cryptoPrice ? crypto.cryptoPrice.toFixed(2).replace('.00', ''):"0"}</td>
        </tr>
      );
    });
  };

  return unauthorized ? (
    <Unauthorized />
  ) : (
    <>
      <Header />
      {/* Page content */}
      <Container className="mt--9 main-content" fluid>
        <Card className="card-height shadow">
          <CardHeader>
            <div className="text-center">
              <h1>Crypto</h1>
            </div>
          </CardHeader>
          <CardBody className="taxes-main-content">
            <Row>
              <Col md="10" lg="8">
                <Row>
                  <Col className="d-flex align-items-center mt-2">
                    <Label className="form-control-label mb-0">Start:</Label>
                    <Input
                      type="date"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </Col>
                  <Col className="d-flex align-items-center mt-2">
                    <Label className="form-control-label mb-0">End:</Label>
                    <Input
                      type="date"
                      value={endDate}
                      onChange={(e) => setEndDate(e.target.value)}
                    />
                  </Col>
                  <Col className="mt-2">
                    <Button
                      color="primary"
                      size="sm"
                      onClick={(e) => {
                        props.fetchCryptoListing(startDate, endDate);
                      }}
                    >
                      Update Date Range
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Table
              className="ticket-table table-listing mt-2"
              responsive
              bordered
            >
              <thead className="thead-light">
                <tr>
                  <th scope="col">Ticket #</th>
                  <th scope="col">Time</th>
                  <th scope="col">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan="2" className="text-right mr-4">
                    <strong className="mr-4">Total:</strong>
                  </td>
                  <td colSpan="2">${props.total.toString().replace('.00', '')}</td>
                </tr>
                {renderTaxesTableData()}
                <tr>
                  <td colSpan="2" className="text-right mr-4">
                    <strong className="mr-4">Total:</strong>
                  </td>
                  <td colSpan="2">${props.total.toString().replace('.00', '')}</td>
                </tr>
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Container>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    cryptodata: state.CryptoReducer.cryptoData,
    total: state.CryptoReducer.total,
    cryptoError: state.CryptoReducer.error,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchCryptoListing: (startDate, endDate) =>
      dispatch(fetchCryptoListing(startDate, endDate)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Crypto);
